import { Sheet, SheetContent, SheetDescription, SheetHeader, SheetTitle } from "@/components/layout";
import { AiAssistedDisclaimer } from "@/components/shared";
import type { TReadinessCategory } from "./types";

type TReasoningPanelProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  categoryName: string;
  category: TReadinessCategory;
};

export function ReasoningPanel({ open, onOpenChange, categoryName, category }: TReasoningPanelProps) {
  const reasoning = category.reasoning?.trim() ?? "";
  const scoreExplanation = category.score_explanation?.trim() ?? "";
  const hasContent = reasoning.length > 0 || scoreExplanation.length > 0;

  return (
    <Sheet
      open={open}
      onOpenChange={onOpenChange}
    >
      <SheetContent
        side="right"
        className="w-full max-w-md overflow-y-auto sm:max-w-lg"
      >
        <SheetHeader>
          <SheetTitle className="font-semibold tracking-tight text-foreground">{categoryName}</SheetTitle>
          <SheetDescription className="text-left text-sm text-muted-foreground">
            How this score was determined and what it means for investor readiness.
          </SheetDescription>
        </SheetHeader>
        <AiAssistedDisclaimer
          variant="compact"
          context="diagnostic"
          className="mt-4"
        />
        <div className="mt-6 space-y-6 font-sans text-sm leading-relaxed">
          {reasoning && (
            <section>
              <h3 className="mb-2 text-xs font-semibold uppercase tracking-wider text-muted-foreground">Reasoning</h3>
              <p className="whitespace-pre-wrap text-foreground">{reasoning}</p>
            </section>
          )}
          {scoreExplanation && (
            <section>
              <h3 className="mb-2 text-xs font-semibold uppercase tracking-wider text-muted-foreground">Score explanation</h3>
              <p className="whitespace-pre-wrap text-foreground">{scoreExplanation}</p>
            </section>
          )}
          {!hasContent && <p className="italic text-muted-foreground">No reasoning or score explanation available.</p>}
        </div>
      </SheetContent>
    </Sheet>
  );
}
